import { useMemo } from 'react';
import { SelectOptionType } from '../../../components/dialog/helper';
import { useDebounce } from '../../../hooks/debounce/use-debounce';
import { useGetTimeZones } from '../../../integrations/lavva/api/installation/installation.hooks';
import { mapTimeZonesToOptions } from '../utils';

export const useTimeZones = () => {
  const { data, isLoading } = useGetTimeZones();
  const { inputValue, inputQuery, setInputValue } = useDebounce();

  const timeZonesOptions: SelectOptionType<string>[] = useMemo(
    () => mapTimeZonesToOptions(data, inputQuery),
    [data, inputQuery],
  );

  return {
    timeZonesOptions,
    isLoading,
    inputValue,
    setInputValue,
  };
};
